var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-time-select',{attrs:{"disabled":_vm.disabled,"picker-options":{
  start: '00:00',
  step: '00:01',
  end: '23:59'
},"placeholder":_vm.fcz.tableTypeDesc},on:{"change":_vm.commonComponent},model:{value:(_vm.fcz.commonDataInfo),callback:function ($$v) {_vm.$set(_vm.fcz, "commonDataInfo", $$v)},expression:"fcz.commonDataInfo"}})
}
var staticRenderFns = []

export { render, staticRenderFns }